<template>
  <div>
    <el-top-nav-menu-4
      :logo="logoBase"
      :companyTitle="title"
      :dashboard="baseUrl"
      :Menu4Href="true"
      width="1180px"
      ref="topNavMenu"
    >
      <!-- 我已注册，查看审批进展 -->
      <!-- <div class="ldg" @click="goApproval">
        <span class="dpng">{{ $t("page.applyUsername.btn.msg10") }}</span>
        <div class="los">
          <img :src="leftgg" />
        </div>
      </div> -->
    </el-top-nav-menu-4>
    <template v-if="orderPurchaseType == 9">
      <topTip></topTip>
      <div style="margin-top: 58px"></div>
    </template>
    <template v-else>
      <topTip v-if="isActive == 1"></topTip>
      <div style="margin-top: 58px" v-if="isActive == 1"></div>
    </template>
    <fledNav />

    <div class="main-wrapper">
      <div class="business-open-shop" style="padding-bottom: 50px">
        <div class="name-check" style="justify-content: center; height: auto">
          <div class="content-center" style="width: auto">
            <div
              :class="
                isActive >= item.active
                  ? 'content-block mryu block-active'
                  : 'content-block mryu'
              "
              v-for="(item, idx) in stepList"
              :key="idx"
              @click="clickStep(item.active)"
            >
              <div class="border-radius">
                <div
                  class="step-block"
                  style="font-family: PingFangSC-Semibold, PingFang SC"
                >
                  {{ idx + 1 }}
                </div>
              </div>
              <span style="font-family: PingFangSC-Regular, PingFang SC">{{
                item.name
              }}</span>
              <ul v-if="idx < stepList.length - 1">
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="active-box yu-flex">
          <div v-show="isActive == 1">
            <div style="margin-bottom: 60px" v-if="orderPurchaseType == 9">
              <div class="ccui-top-title">注册联系人</div>
              <phoneCode ref="phoneCodeRef"></phoneCode>
            </div>
            <ready-info :cost="orderMoney"></ready-info>
          </div>
          <div v-show="isActive == 2">
            <apply-info ref="applyInfo"></apply-info>
          </div>
          <div v-show="isActive == 3" style="width: 100%">
            <pay-info
              v-if="orderPurchaseType != 9"
              ref="payInfo"
              @reloimg="reloimg"
            ></pay-info>
            <wl-pay-info
              ref="payInfo"
              v-else
              :orderCode="orderCode"
              @reloimg="reloimg"
              @wuliuPayTypeChange="wuliuPayTypeChange"
            ></wl-pay-info>
          </div>
          <div v-show="isActive == 2.1">
            <line-info ref="lineInfo" @success="lineAddSuccess"></line-info>
          </div>
        </div>

        <div class="yu-flex yu-flex-col" style="margin-top: 20px">
          <template v-if="orderPurchaseType != 10">
            <div
              style="font-size: 13px; color: #9b9b9b; margin-bottom: 20px"
              v-show="isActive == 1"
            >
              <el-checkbox
                v-model="checked"
                style="margin-right: 5px"
                @change="changeWlXy"
              />我已阅读并接受
              <span
                style="color: #f50b25; cursor: pointer"
                @click="shopagreementHand"
                >{{
                  orderPurchaseType == 9
                    ? "《承运商合作框架协议》"
                    : "《商家入驻协议》"
                }}</span
              >
            </div>
            <div
              v-if="checked && isActive == 1"
              class="combtn data-bottom-btn"
              @click="nextStepClick"
            >
              {{ orderPurchaseType == 9 ? "验证手机号并继续" : "下一步" }}
            </div>
            <div
              v-if="!checked && isActive == 1"
              class="combtn data-bottom-btn1"
            >
              {{ orderPurchaseType == 9 ? "验证手机号并继续" : "下一步" }}
            </div>
          </template>
          <div
            class="combtn data-bottom-btn"
            v-if="isActive == 2.1"
            @click="addLine"
          >
            提交运力线路
          </div>
          <div
            v-if="orderPurchaseType == 10 && isActive == 1"
            class="combtn data-bottom-btn"
            @click="nextStepClick"
          >
            下一步
          </div>

          <div
            v-show="isActive == 2"
            class="combtn data-bottom-btn"
            @click="saveApply"
          >
            提交申请
          </div>
          <div
            v-show="isActive == 3 && wuliuPayType === 4 && wuliuBtnShow"
            class="combtn data-bottom-btn"
            @click="wuliuGDG"
          >
            提交
          </div>
          <div
            style="display: flex; justify-content:space-between; width: 500px;"
            v-show="
              orderPurchaseType == 9 &&
                isActive == 3 &&
                wuliuPayType === 2 &&
                !lastSuccess
            "
          >
            <div
              class="combtn data-bottom-btn"
              style="width: 230px;"
              @click="handelTijaio(1)"
            >
              提交
            </div>
            <div
              class="combtn data-bottom-btn"
              style="width: 230px;"
              @click="handelTijaio(2)"
            >
              试运行
            </div>
          </div>
          <div
            v-show="orderPurchaseType == 9 && isActive == 3 && lastSuccess"
            class="combtn data-bottom-btn"
            @click="goApproval"
          >
            查看审批进度
          </div>
        </div>

        <el-dialog
          class="dialog-center"
          title="提示"
          :visible.sync="dialogVisible2"
          :show-close="false"
          width="300px"
          show-divider
          show-shadow
          custom-class="el-dialog--customize"
        >
          <span>网络请求超时，请稍后再试</span>
          <span slot="footer" style="text-align: center">
            <el-button
              size="mini"
              type="primary-font-mini"
              @click="closeModalTimeout"
              >确定</el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
    <el-dialog
      title="商家入驻协议"
      :visible.sync="shopagreement"
      width="700px"
      show-divider
      show-shadow
      class="dialog-center"
      custom-class="el-dialog--customize"
    >
      <div v-if="agreementsUrl" style="height: 530px">
        <iframe
          :src="agreementsUrl + '#toolbar=0&view=FitH'"
          frameborder="0"
          style="width: 100%; height: 100%; overflow: auto"
        ></iframe>
      </div>
      <span slot="footer">
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="shopagreement = false"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="承运商合作框架协议"
      :visible.sync="shopagreement9"
      width="700px"
      :closeOnPressEscape="false"
      :show-close="false"
      show-divider
      :footer="null"
      show-shadow
      class="dialog-center"
      custom-class="el-dialog--customize"
    >
      <div v-if="agreementsUrl" style="height: 10700px">
        <iframe
          :src="agreementsUrl + '#toolbar=0&view=FitH'"
          frameborder="0"
          style="width: 100%; height: 100%"
        ></iframe>
        <div style="padding: 20px">
          <el-button size="mini" type="primary-font-mini" @click="wlxyRead"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import logoYc from "./images/logoYc.png";
import logoZl from "./images/logoZl.png";
import logoWl from "./images/logoWl.png";
import logoZJyc from "./images/logoZJyc.png";
import readyInfo from "./ready/index.vue";
import applyInfo from "./apply/index.vue";
import payInfo from "./pay/zlNewPay.vue";
import lineInfo from "./line/index.vue";

import wlPayInfo from "./pay/wlIndex.vue";
import topTip from "@/views/lessor-open-shop/components/topTip.vue";
import fledNav from "@/views/lessor-open-shop/components/fled-nav.vue";
import phoneCode from "./components/phoneCode.vue";

import {
  queryShopAnnualFeeOrderPage,
  qryShopDetailByPhone
} from "@/views/lessor-open-shop/api.js";
import { validAuthCode } from "@/api/register-shop";
import {
  addShopByClp,
  shopSubmit,
  getWayChatPay,
  getStatus,
  qryShopfeeCompanyBillConfig,
  saveShopfeeCompanyTransferBill,
  startProcess
} from "@/api/lessor-open-shop.js";
export default {
  name: "index",
  provide() {
    return {
      getWLOptions: this.wuliuOptions,
      gongduigongInfo: this.shopfeeCompanyTransferBillRspBO
    };
  },
  components: {
    readyInfo,
    applyInfo,
    payInfo,
    topTip,
    fledNav,
    wlPayInfo,
    phoneCode,
    lineInfo
  },
  data() {
    return {
      businessId: "",
      addlineTips: "",
      transferOrderId: "",
      lastSuccess: false,
      checked: false,
      shopagreement: false,
      shopagreement9: false,

      agreementsUrl: null,

      timer: null,
      applyData: {},
      title: "开店申请",
      // 8 云租 9 物流  10 二级集采 11 仓库方
      obj: {
        8: "租赁商开店申请",
        9: "承运商开店申请",
        10: "二级集采开店申请",
        11: "仓库方开店申请"
      },
      orderPurchaseType: 8,
      baseUrl: "",
      logoBase: "",
      leftgg: require("@/assets/images/llop.png"),
      nameList: [
        { name: "注册须知", active: 1 },
        { name: "开店申请", active: 2 },
        { name: "扫码支付", active: 3 }
      ],
      userPhone: "",
      shopId: "",
      phoneInfo: {},
      nameListWl: [
        { name: "注册须知", active: 1 },
        { name: "开店申请", active: 2 },
        { name: "完善运力线路", active: 2.1 },
        { name: "提交", active: 3 }
      ],
      stepList: [],
      isActive: 1,
      orderMoney: "3000.00",
      orderCode: "",
      // 物流店铺年费配置信息查询
      wuliuOptions: {
        orderMoney: "",
        receiveBankName: "",
        receiveBankAccount: "",
        openBankName: "",
        openBankFullName: "",
        transferNotes: "",
        financialAddressInfo: "",
        payTypeList: []
      },
      wuliuPayType: 2,
      wuliuBtnShow: true,
      shopfeeCompanyTransferBillRspBO: {} //公对公支付信息
    };
  },
  mounted() {
    console.log(process.env.NODE_ENV, "-*-*-process.env.NODE_ENV*-*--*-");
    console.log(this.getMoney(), "-*-*-this.getMoney*-*--*-");
    localStorage.removeItem("zipCodes");
    const { orderPurchaseType } = this.$route.query;
    if (orderPurchaseType) {
      this.orderPurchaseType = orderPurchaseType;
    }
    this.title = this.obj[this.orderPurchaseType];
    this.stepList =
      this.orderPurchaseType == 9 ? this.nameListWl : this.nameList;
    if (this.orderPurchaseType == 8) {
      this.baseUrl = this.$addUrlPerFix("yz.iccec.cn");
      this.logoBase = logoZl;
      this.agreementsUrl =
        "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com:443/cccc_home/100112/default/202412/c6b15028026040288881f17ded4c127c.pdf";
    } else if (this.orderPurchaseType == 9) {
      this.baseUrl = this.$addUrlPerFix("wl.iccec.cn");
      this.logoBase = logoWl;
      this.agreementsUrl =
        // "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com:443/cccc_home/100112/default/202412/62432fc155c94de28ca724c2a2a3d49d.pdf";
        "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/cccc_home/100112/default/202506/c8b6c97485074ec280d91328a5a273bc.pdf";
    } else if (this.orderPurchaseType == 10) {
      this.logoBase = logoYc;
      this.baseUrl = this.$addUrlPerFix(process.env.VUE_APP_SHOPPAGE_URL);
      this.agreementsUrl =
        "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com:443/cccc_home/100112/default/202412/39686322c607476f9bf19adf3c5e765b.pdf";
    } else if (this.orderPurchaseType == 11) {
      this.logoBase = logoZJyc;
      this.baseUrl = this.$addUrlPerFix("yc.iccec.cn");
      this.agreementsUrl =
        "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/cccc_home/100112/default/202412/f056f1eb890647f38d76afc88394c9f7.pdf";
    }
    // 物流店铺年费配置信息查询
    if (this.orderPurchaseType == 9) {
      this.qryShopfeeCompanyBillConfig();
    }

    //     商家入驻协议--物流
    // 10072796205
    // https://cccc-prod.obs.cn-north-4.myhuaweicloud.com:443/cccc_home/100112/default/202412/62432fc155c94de28ca724c2a2a3d49d.pdf

    // 商家入驻协议--云租.pdf
    // 10072794744
    // https://cccc-prod.obs.cn-north-4.myhuaweicloud.com:443/cccc_home/100112/default/202412/c6b15028026040288881f17ded4c127c.pdf

    // 商家入驻协议-中交云采.pdf
    // 10072796216
    // https://cccc-prod.obs.cn-north-4.myhuaweicloud.com:443/cccc_home/100112/default/202412/39686322c607476f9bf19adf3c5e765b.pdf
  },
  computed: {
    dialogVisible2() {
      return this.$store.state.app.isShowDialogTimeout;
    }
  },
  beforeRouteLeave(to, from, next) {
    // 在这里执行离开路由前的操作
    console.log("离开路由", from.path, "前往路由", to.path);
    // 清理数据或者保存状态
    clearInterval(this.timer);
    localStorage.removeItem("zipCodes");
    // 不要忘记调用 next() 方法来确认导航
    next();
  },
  methods: {
    // 我已注册
    goApproval() {
      this.$router.push({
        path: "/approval/detail",
        query: {
          orderPurchaseType: this.orderPurchaseType,
          phone: this.userPhone,
          shopId: this.shopId
        }
      });
    },
    async qryShopfeeCompanyBillConfig() {
      const res = await qryShopfeeCompanyBillConfig({ shopFeeType: 1 });
      res.data.data.orderMoney = res.data.data.orderMoney.toFixed(2);
      this.orderMoney = res.data.data.orderMoney;
      Object.assign(this.wuliuOptions, res.data.data);
      this.$refs.payInfo.payTypeChange(2);
      // if (this.wuliuOptions.payTypeList && this.wuliuOptions.payTypeList[0]) {
      //   this.$refs.payInfo.payTypeChange(this.wuliuOptions.payTypeList[0]);
      // }
    },
    async nextStepClick() {
      if (this.orderPurchaseType == 9) {
        let res = await this.$refs.phoneCodeRef.submitPhone();
        validAuthCode({
          phone: res.phone,
          authCode: res.authCode,
          isShowLoading: true
        }).then(res => {
          if (res.data.code == "0") {
            this.isActive = 2;
            this.checkShopPhone();
          } else {
            reject(res.data.message);
          }
        });
      } else {
        this.isActive = 2;
        localStorage.setItem("isActive", 2);
        this.$refs.applyInfo.getMoRenBusinessName();
      }
    },
    async checkShopPhone() {
      try {
        let res = await this.$refs.phoneCodeRef.submitPhone();
        console.log(res, "*-*-*-*-*");
        this.phoneInfo = res;
        this.userPhone = res.phone;
        this.$refs.applyInfo.setPhoneInfo(res); //申请页面填写手机号验证码信息
        this.getQryShopDetailByPhone(res.phone);
      } catch (error) {
        console.log(error);
      }
    },

    // 手机号查店铺
    getQryShopDetailByPhone(phone) {
      qryShopDetailByPhone({ phone, isShowLoading: true }).then(res => {
        console.log(res, "*-*-手机号查店铺*-*-*");
        sessionStorage.removeItem("gongduigongInfo");
        if (res.data.code == 0) {
          const {
            shopId,
            approveStatus,
            shopManagerPhone,
            shopManager,
            businessId
          } = res.data.data;
          // 下次进来获取用户名和手机号
          this.applyData.phone = shopManagerPhone;
          this.applyData.contactName = shopManager;
          this.businessId = businessId;
          // 待审批审批通过 3 2
          if ([3, 2].includes(approveStatus)) {
            this.isActive = 1;
            //审批通过
            this.$confirm.alert(
              "您已使用申请手机号验证完成身份验证，可查询开店申请审批进度。",
              "提示",
              {
                distinguishCancelAndClose: true,
                showClose: false,
                dangerouslyUseHTMLString: true,
                confirmButtonText: "查询开店申请审批进度",
                customClass: "ccui-message-box-custom",
                callback: action => {
                  if (action === "confirm") {
                    this.goApproval();
                  }
                }
              }
            );
          } else {
            if ([4].includes(approveStatus) && this.isActive == 2) {
              //审批退回
              this.$confirm.alert(
                "您的开店申请已被退回，请重新提交申请！",
                "提示",
                {
                  distinguishCancelAndClose: true,
                  showClose: false,
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: "确认",
                  customClass: "ccui-message-box-custom"
                }
              );
            }
            // 已开店
            if (shopId) {
              this.shopId = shopId;
              this.$refs.applyInfo.setShopInfo(res.data.data); //申请页面填写店铺信息
              sessionStorage.setItem("shopInfo", JSON.stringify(res.data.data));
              this.$refs.lineInfo.getShopInfo(res.data.data);
              this.getQueryShopAnnualFeeOrderPage(phone);
            } else {
              this.$refs.applyInfo.rsetShopData(); //申请页面初始化
              sessionStorage.removeItem("shopInfo");
              this.$refs.applyInfo.setPhoneInfo(this.phoneInfo); //申请页面填写手机号验证码信息
              // this.isActive = 2;
            }
          }
        }
      });
    },
    // 手机号查订单
    getQueryShopAnnualFeeOrderPage(phone) {
      queryShopAnnualFeeOrderPage({
        phone,
        orderPurchaseType: 9,
        isShowLoading: true
      }).then(res => {
        console.log(res, "*-*-手机号查订单*-*-*");

        let orders = res.data.data.rows.find(
          item => item.orderTypeName == "开店申请"
        );
        // 待支付
        if (orders) {
          this.transferOrderId = orders.shopfeeCompanyTransferBillRspBO
            ? orders.shopfeeCompanyTransferBillRspBO.transferOrderId
            : "";
          this.orderCode = orders.orderCode; //支付页面填写订单信息

          if (orders.shopfeeCompanyTransferBillRspBO) {
            this.shopfeeCompanyTransferBillRspBO =
              orders.shopfeeCompanyTransferBillRspBO;
            sessionStorage.setItem(
              "gongduigongInfo",
              JSON.stringify(orders.shopfeeCompanyTransferBillRspBO)
            );
          }

          if (orders.payStatus == 0) {
            //待支付 显示二维码
            localStorage.setItem("zipCodes", orders.zipCodes);
          } else if ([1].includes(orders.payStatus)) {
            //已支付 显示成功
            // this.$refs.payInfo.paySuccess();
          } else if ([6].includes(orders.payStatus)) {
            //支付待确认
          } else {
            // this.isActive = 2;
          }
        } else {
          this.transferOrderId = "";
          // this.isActive = 2;
        }
      });
    },

    shopagreementHand() {
      if (this.orderPurchaseType == 9) {
        this.shopagreement9 = true;
      } else {
        this.shopagreement = true;
      }
    },
    clickStep(active) {
      //  this.isActive = active; //开发时打开
      if (active == 1) {
        this.isActive = active;
        localStorage.setItem("isActive", 1);
      }
      // if (this.orderPurchaseType == 9) {
      //   if (active <= this.stepNow && !this.lastSuccess) {
      //     this.isActive = active;
      //     localStorage.setItem("isActive", 1);
      //   }
      // } else {
      //   if (active == 1) {
      //     this.isActive = active;
      //     localStorage.setItem("isActive", 1);
      //   }
      // }
    },
    addLine() {
      // // 如果已经添加了线路 则直接进行先一步支付
      // if (this.addlineTips) {
      //   this.$message.warning({
      //     message: this.addlineTips,
      //     type: "error",
      //     duration: 2000,
      //     ccuiCustom: true,
      //     showClose: true,
      //     offset: document.body.clientHeight / 2 - 21,
      //   });
      //   this.isActive = 3;
      //   return;
      // }
      this.$refs.lineInfo.saveValid(1);
    },
    lineAddSuccess(type) {
      if (type == "add") {
        this.addlineTips = "已提交运力线路！";
      } else {
        this.addlineTips = "";
      }
      this.isActive = 3;
      //提交运力线路后刷新支付二维码
      this.reloimg();
      if (!this.orderCode) {
        this.shopSubmit(this.applyData.phone, this.applyData.contactName);
      }
    },
    async saveApply() {
      const { applyInfo } = this.$refs;
      try {
        const applyData = await applyInfo.handleSubmit();
        this.applyData = applyData;

        addShopByClp({
          ...applyData,
          businessId: this.businessId,
          isShowLoading: true
        }).then(res => {
          if (res.data.code == 0) {
            if (this.orderPurchaseType == 9) {
              let flag =
                applyData.shopSupplierSubcategoryBOList.filter(
                  item => item.subcategoryCode == 0 || item.subcategoryCode == 2
                ).length > 0;
              console.log(flag, "flag");
              //物流的开店后
              if (flag) {
                // 如果选择的承运商类型包含公路承运人或者无车承运人， 先铺货再支付
                this.isActive = 2.1;
                this.checkShopPhone();
              } else {
                //否则经营类目不需要填写，线路不用填，直接跳转支付
                this.isActive = 3;
                this.shopSubmit(
                  this.applyData.phone,
                  this.applyData.contactName
                );
              }
            } else {
              this.isActive = 3;
              this.shopSubmit(this.applyData.phone, this.applyData.contactName);
            }
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    reloimg() {
      clearInterval(this.timer);
      // 从新支付
      const zipCodes = localStorage.getItem("zipCodes");
      if (zipCodes) {
        this.getWayChatPay(
          zipCodes,
          this.applyData.contactName,
          this.applyData.phone
        );
      } else {
        this.$message.warning("刷新失败，请尝试使用公对公转账！");
        // this.$refs.payInfo.payTypeChange(4);
      }
    },
    getMoney() {
      const o = window.location;
      const hostname = o.hostname;
      const regex = /^([^-\s]*)/;
      const match = hostname.match(regex);
      // 物流开店金额从配置中获取
      if (this.orderPurchaseType == 9) {
        return Number(this.orderMoney);
      }
      switch (match[1]) {
        case "dev01": {
          return 0.01;
        }
        case "test01": {
          return 0.01;
        }
        case "uat01": {
          return 0.01;
        }
        default: {
          return 3000;
        }
      }
    },
    // 下单
    shopSubmit(phone, name) {
      const money = this.getMoney();
      const da = {
        submitBasicInfoBO: {
          orderPurchaseType: this.orderPurchaseType,
          orderType: 11,
          payType: 2,
          totalMoney: money,
          isShowLoading: true
        },
        skuDetailInfoBOS: [
          {
            skuName: "店铺年服务费",
            purchaseCount: 1,
            sellingPrice: money,
            skuId: "999999999",
            total: money
          }
        ],
        phone: phone,
        personName: name
      };
      shopSubmit(da).then(res => {
        if (res.data.code == 0) {
          console.log(res, "*-*-*-*-*");
          const { zipCodes, orderCodes } = res.data.data;
          this.orderCode = orderCodes[0];
          localStorage.setItem("zipCodes", zipCodes);

          this.getWayChatPay(zipCodes, name, phone);
        }
      });
    },
    getWayChatPay(code, name, phone) {
      const das = {
        orderCodes: code,
        phone: phone,
        personName: name,
        isShowLoading: true
      };
      getWayChatPay(das).then(res => {
        this.$refs.payInfo.startDJS(res.data.data);

        this.timer = setInterval(() => {
          this.queryOrderPayStatus();
        }, 5000);
      });
    },
    // 支付状态查询
    queryOrderPayStatus() {
      const zipCodes = localStorage.getItem("zipCodes");
      getStatus({
        orderCodes: zipCodes, //加密后的订单编号
        phone: this.applyData.phone
      }).then(res => {
        if (res.data.code == 0) {
          // "allPay": 0 //是否支付成功  0未成功  1成功 2失败 3取消
          if (res.data.data.allPay == 1) {
            this.$message.success("支付成功！");
            clearInterval(this.timer);
            this.$refs.payInfo.paySuccess(res.data.data);
          }
        }
      });
    },
    closeModalTimeout() {
      this.$store.commit("SET_IS_SHOW_DIALOG_TIMEOUT", false);
    },
    goHomePage() {
      this.$router.push("/index");
    },
    changeWlXy(val) {
      if (val && this.orderPurchaseType == 9) {
        this.shopagreement9 = true;
      }
    },
    wlxyRead() {
      this.checked = true;
      this.shopagreement9 = false;
      // 打开签名询问框
      this.$confirm.alert(
        '请使用电子签签订协议，<a class="ccui-message-box-custom-link" href="https://docs.qq.com/doc/DUkVGTVpGYWNDc01h" target="_blank" style="color: #FF142F;">查看电子签操作手册</a>',
        "签订协议提示",
        {
          distinguishCancelAndClose: true,
          showClose: false,
          dangerouslyUseHTMLString: true,
          confirmButtonText: "去签约",
          customClass: "ccui-message-box-custom",
          callback: action => {
            if (action === "confirm") {
              window.open("https://aimarket.iccec.cn/", "_blank");
            }
          }
        }
      );
    },
    wuliuPayTypeChange(type) {
      this.wuliuPayType = type;
    },
    async wuliuGDG() {
      const res = await this.$refs.payInfo.validateForm();
      if (!res) return;
      const {
        receiveBankName,
        receiveBankAccount,
        transferNotes,
        financialAddressInfo
      } = this.wuliuOptions;
      let params = {
        transferId: this.wuliuOptions.transferId,
        createAgentId: 100029,
        orderCode: this.orderCode,
        receiveBankName,
        receiveBankAccount,
        transferNotes,
        financialAddressInfo,
        ...res
      };
      const result = await saveShopfeeCompanyTransferBill(params);
      // this.wuliuBtnShow = false;
      // this.$refs.payInfo.paySuccess();
      setTimeout(() => {
        this.handelTijaio(1);
      }, 1000);
      clearInterval(this.timer);
    },
    handelTijaio(flag) {
      startProcess({
        phone: this.userPhone,
        transferOrderId: this.transferOrderId,
        submitFlag: flag, //提交标识 1：提交 2：试运行
        isShowLoading: true
      }).then(res => {
        console.log(res);
        if (res.data.code == 0) {
          this.$refs.payInfo.paySuccess(res.data.data);
          this.lastSuccess = true;
          this.wuliuBtnShow = false;
        } else {
          this.lastSuccess = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-top-nav-menu4 {
  .sub-menu-wrapper-wrapper {
    .sub-menu-wrapper {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
}

.name-check .content-center .mryu {
  margin-right: 120px;
  width: 52px;
  display: flex;
  flex-direction: column;
  align-items: center;
  &:last-child {
    margin-right: 0;
  }
}
.yu-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.yu-flex-col {
  flex-direction: column;
}
.active-box {
  margin-top: 20px;
  background: #ffffff;
  padding: 20px 0;
}
.main-wrapper,
.headerContent {
  /*min-width: 1263px;*/
  /*max-width: 1680px;*/
  width: 1180px;
  margin: 0 auto;
}
/* header */
.header {
  cursor: pointer;
  /*min-width:  .main-wrapper1080px;*/
  /*max-width: 1680px;*/
  height: 80px;
  background: rgba(255, 20, 47, 1);
  position: relative;
}
.headerLogo {
  width: 115px;
  height: 40px;
  position: absolute;
  top: 20px;
  left: 50px;
}
.headerLine {
  display: block;
  width: 1px;
  height: 16px;
  background: rgba(255, 255, 255, 1);
  border-radius: 1px;
  position: absolute;
  top: 32px;
  left: 171px;
}
.header .headerTxt {
  width: 128px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  position: absolute;
  top: 29px;
  left: 178px;
}
.business-open-shop {
  /*padding: 0 50px 0 50px;*/
  /*margin-bottom: 20px;*/
}
.combtn {
  margin-bottom: 20px;
  font-family: PingFangSC-Semibold, PingFangSC;
  font-weight: 600;
}

.ldg {
  float: right;
  margin-top: 30px;
  cursor: pointer;
}

.dpng {
  font-size: 16px;
  color: #ffffff;
  line-height: 18px;
  float: left;
  margin-right: 10px;
}

.los img {
  width: 100%;
}

.los {
  width: 18px;
  height: 18px;
  float: left;
}
</style>
